import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const LocationRoutes = defineRoute({
    customer: {
        route: {
            path: "/location/customers",
            component: () => loadView(import("./LocationCustomer.vue")),
        },
    },
    reseller: {
        route: {
            path: "/location/resellers",
            component: () => loadView(import("./LocationReseller.vue")),
        },
    },
    pop: {
        route: {
            path: "/location/pops",
            component: () => loadView(import("./LocationPOP.vue")),
        },
    },
});
